const HOST_READY_EVENT = 'lectrium-host-ready'
const IS_HOST_READY_EVENT = 'lectrium-is-host-ready'

/**
 * Always turned on check that iframe can call and get response from host
 * This is to ensure that if iframe reloads, host can still respond to ready checks
 */
export function setupReadyCheckListener(iframe: HTMLIFrameElement) {
  const handleIsHostReady = (event: MessageEvent) => {
    if (
      //
      event.source !== iframe.contentWindow ||
      event.data?.type !== IS_HOST_READY_EVENT ||
      !iframe.contentWindow
    ) {
      return
    }
    iframe.contentWindow.postMessage({ type: HOST_READY_EVENT }, '*')
  }
  window.addEventListener('message', handleIsHostReady)

  return () => {
    window.removeEventListener('message', handleIsHostReady)
  }
}

export function notifyHostReady(iframe: HTMLIFrameElement): void {
  iframe.contentWindow?.postMessage({ type: HOST_READY_EVENT }, '*')
}

export interface WaitForHostReadyProps {
  onTimeout?: () => void
}

export function waitForHostReady({ onTimeout }: WaitForHostReadyProps = {}): Promise<void> {
  if (typeof window === 'undefined' || window.parent === window) {
    return Promise.resolve()
  }

  return new Promise(resolve => {
    const timeout = setTimeout(() => {
      onTimeout?.()
      // we don't really want to reject the promise, in case it would still resolve later
      // However, we want to notify our Sentry to investigate why host didn't respond
    }, 60_000)

    const readyHandler = (event: MessageEvent) => {
      if (window.parent === window || event.data?.type !== HOST_READY_EVENT) {
        return
      }

      clearTimeout(timeout)
      window.removeEventListener('message', readyHandler)
      resolve()
    }

    // Ask host if it's ready
    if (window.parent !== window) {
      window.parent.postMessage({ type: IS_HOST_READY_EVENT }, '*')
    }

    window.addEventListener('message', readyHandler)
  })
}
